window.angular.module('MyHippoProducer.Components').directive('sideNavSubsection', function () {
    return {
        restrict: 'E',
        scope: { label: '@', active: '<', hasError: '<' },
        templateUrl: 'components/side-nav/subsection/subsection.html',
    };
});
